<script setup>
import Grid from "../../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import usersSearchesService from "@/services/users-searches.service";
import {onMounted, ref} from "vue";

const {gridParams, gridMethods, items} = useGrid(getList);
const filters = ref([]);

const columns = [
    {
        label: 'Company ID',
        name: 'company_id',
        filter: 'text',
    },
    {
        label: 'Company Name',
        name: 'company_name',
        filter: 'text',
    },
    {
        label: 'User',
        name: 'email',
        filter: 'text',
    },
    {
        label: 'Service',
        name: 'service',
        filter: 'single-select',
        options: [
            {
                id: 'gpt',
                name: 'gpt'
            },
            {
                id: 'ppx',
                name: 'ppx'
            }
        ]
    },
    {
        label: 'Search Text',
        name: 'search_text',
        filter: 'text',
    },
    {
        label: 'Response',
        name: 'response',
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
    },
];

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function changeFilters(newFilters) {
    filters.value = newFilters;
    gridMethods.resetList();
}

function getList(pageParams) {
    return usersSearchesService.getAiResponses(pageParams, filters.value);
}
</script>

<template>
    <div>
        <div class="topbar">
            <div class="tabs tabs-primary">
                <b-nav tabs>
                    <b-nav-item href="users-search-history">
                        Users Searches
                    </b-nav-item>

                    <b-nav-item active>
                        AI Responses
                    </b-nav-item>
                </b-nav>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="items"
                    :has-filters="true"
                    :page-length="gridParams.pageLength"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="changeFilters"
                >
                </Grid>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
